import { render, staticRenderFns } from "./ageMonthPage.vue?vue&type=template&id=58af5a37&"
import script from "./ageMonthPage.vue?vue&type=script&lang=js&"
export * from "./ageMonthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports